<template>
  <div>
    <el-menu :default-active="$route.path" router class="el-menu-vertical-demo menu " @open="handleOpen" v-if="flag"
      @close="handleClose" :collapse="isCollapse" background-color="rgb(0,21,41)" text-color="#fff"
      active-text-color="#ffd04b">
      <!-- <div @click="isCollapse = !isCollapse" class="top">
      <i class="el-icon-set-up"></i>
    </div> -->
      <template v-for="(item, index) in Routers">
        <el-menu-item v-if="item.noDropdown" :key='index' :index="item.name">
          <i :class="item.meta.icon"></i>
          <span>{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
      <template v-for="(item, index) in Routers">
        <el-submenu v-if="!item.noDropdown" :key='index' :index="item.name">
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{ item.meta.title }}</span>
          </template>
          <el-menu-item v-for="(citem, cindex) in item.children" :key="cindex" :index="citem.name">{{ citem.meta.title
          }}</el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
    <el-menu :default-active="$route.path" router class="el-menu-vertical-demo2 menu " @open="handleOpen" v-if="!flag"
    @select="handleSelect"
      @close="handleClose" :collapse="isCollapse" background-color="rgb(0,21,41)" text-color="#fff"
      active-text-color="#ffd04b">
      <template v-for="(item, index) in Routers">
        <el-menu-item v-if="item.noDropdown" :key='index' :index="item.name">
          <i :class="item.meta.icon"></i>
          <span>{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
      <template v-for="(item, index) in Routers">
        <el-submenu v-if="!item.noDropdown" :key='index' :index="item.name">
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{ item.meta.title }}</span>
          </template>
          <el-menu-item v-for="(citem, cindex) in item.children" :key="cindex" :index="citem.name">{{ citem.meta.title
          }}</el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'NavMenu',
  data() {
    return {
      // isCollapse: true,
      Routers: [
        {
          name: '/1',
          noDropdown: false,
          meta: { icon: 'el-icon-menu', title: '控制台' },
          children: [
            { name: '/OverviewBasicData', meta: { icon: '', title: '基本数据概览' } },
            { name: '/RegionalDataStatistics', meta: { icon: '', title: '地区数据统计' } }
          ]
        },
        {
          name: '/2',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '机构管理' },
          children: [
            { name: '/orzInformationManage', meta: { icon: '', title: '机构信息管理' } }
          ]
        },
        {
          name: '/3',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '账号管理' },
          children: [
            { name: '/OrzAccountList', meta: { icon: '', title: '机构账号管理' } },
            { name: '/PatientAccountList', meta: { icon: '', title: '患者账号管理' } }
          ]
        },
        {
          name: '/4',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '设备管理' },
          children: [
            { name: '/CNHTransManage', meta: { icon: '', title: 'CNH发射器管理' } },
            { name: '/DataRecManage', meta: { icon: '', title: '数据接收器管理' } },
            { name: '/HospitalTransManage', meta: { icon: '', title: '医院发射器管理' } }
          ]
        },
        {
          name: '/5',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '审计日志' },
          children: [
            { name: '/LogSetting', meta: { icon: '', title: '日志设置' } },
            { name: '/LoginLog', meta: { icon: '', title: '登录日志' } },
            { name: '/OperationLog', meta: { icon: '', title: '操作日志' } }
          ]
        },
        {
          name: '/6',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '系统账号管理' },
          children: [
            { name: '/SystemAccountManagement', meta: { icon: '', title: '系统账号管理' } },
          ]
        }
      ],
      flag: true
    }
  },
  methods: {
    handleSelect(){
      this.$store.commit("updateCollapse", true)
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    }
  },
  created() {
    let role = sessionStorage.getItem('role')
    console.log(role)
    if (role == 'admin') {
      this.$store.commit("updateCollapse", false)
      this.Routers = [
        {
          name: '/1',
          noDropdown: false,
          icon: '',
          meta: { icon: 'el-icon-location', title: '账户' },
          children: [
            { name: '/accounts', meta: { title: '账户' } },
          ]
        },
        {
          name: '/2',
          noDropdown: false,
          meta: { icon: 'el-icon-menu', title: '控制台' },
          children: [
            { name: '/OverviewBasicData', meta: { icon: '', title: '基本数据概览' } },
            { name: '/RegionalDataStatistics', meta: { icon: '', title: '地区数据统计' } }
          ]
        },
        {
          name: '/3',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '机构管理' },
          children: [
            { name: '/orzInformationManage', meta: { icon: '', title: '机构信息管理' } }
          ]
        },
        {
          name: '/4',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '账号管理' },
          children: [
            { name: '/OrzAccountList', meta: { icon: '', title: '机构账号管理' } },
            { name: '/PatientAccountList', meta: { icon: '', title: '患者账号管理' } }
          ]
        },
        {
          name: '/5',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '设备管理' },
          children: [
            { name: '/CNHTransManage', meta: { icon: '', title: 'CNH发射器管理' } },
            { name: '/DataRecManage', meta: { icon: '', title: '数据接收器管理' } },
            { name: '/HospitalTransManage', meta: { icon: '', title: '医院发射器管理' } }
          ]
        },
        {
          name: '/6',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '审计日志' },
          children: [
            { name: '/LogSetting', meta: { icon: '', title: '日志设置' } },
            { name: '/LoginLog', meta: { icon: '', title: '登录日志' } },
            { name: '/OperationLog', meta: { icon: '', title: '操作日志' } }
          ]
        },
        {
          name: '/7',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '系统账号管理' },
          children: [
            { name: '/SystemAccountManagement', meta: { icon: '', title: '系统账号管理' } },
          ]
        },

      ]
    } else {
      this.$store.commit("updateCollapse", false)
      this.Routers = [
        {
          name: '/1',
          noDropdown: false,
          icon: '',
          meta: { icon: 'el-icon-location', title: '账户' },
          children: [
            { name: '/accounts', meta: { title: '账户' } },
          ]
        },
        {
          name: '/2',
          noDropdown: false,
          meta: { icon: 'el-icon-location', title: '设备管理' },
          children: [
            { name: '/DataRecManageKey', meta: { icon: '', title: '数据接收器管理' } },
            { name: '/HospitalTransManageKey', meta: { icon: '', title: '医院发射器管理' } }
          ]
        },
      ]
    }
    let width = window.innerWidth
    if (width < 700) {
      this.flag = false
    } else {
      this.flag = true
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.isCollapse
    },
  }
}
</script>

<style  scoped>
.el-menu-vertical-demo {
  width: 0px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}
.el-menu-vertical-demo2{
  width: 0px;
}
.el-menu-vertical-demo2:not(.el-menu--collapse) {
  width: 100vw;
}

.top {
  text-align: right;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-icon-set-up {
  color: #fff;
  text-align: left;
  cursor: pointer;
}</style>



// WEBPACK FOOTER //
// src/components/layout/NavMenu.vue